//Services
export const SERVICES_FETCH_SUCCESS = 'SERVICES_FETCH_SUCCESS'
export const SERVICES_CATEGORIES = 'SERVICES_CATEGORIES'
export const SERVICES_FIL_BY_CATEGORY = 'SERVICES_FIL_BY_CATEGORY'
export const SET_SHOW_FIL_SERVICES = 'SET_SHOW_FIL_SERVICES'
export const SET_RESERVED_SERVICES = 'SET_RESERVED_SERVICES'
export const SERVICES_BENEFITS = 'SERVICES_BENEFITS'
export const SET_SERVICE_FILTER = 'SET_SERVICE_FILTER'
export const SET_CRUISE_DATE = 'SET_CRUISE_DATE'
export const SET_SERVICES_LOADING = 'SET_SERVICES_LOADING'
export const SET_BOOKING_DETAILS = 'SET_BOOKING_DETAILS'
export const SET_SELECTED_SERVICE = 'SET_SELECTED_SERVICE'
export const SET_NAV_DATA = 'SET_NAV_DATA'
export const SET_CONTENT_FEED = 'SET_CONTENT_FEED'
export const SET_SELECTED_GUEST_DETAILS = 'SET_SELECTED_GUEST_DETAILS'
export const SET_CANCELED_SERVICE = 'SET_CANCELED_SERVICE'
export const SET_GUEST_PAYER = 'SET_GUEST_PAYER'
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'
export const SET_SPA_ERROR = 'SET_SPA_ERROR'
export const SET_DB_TOKEN = 'SET_DB_TOKEN'

//Reservations
export const FETCH_RESERVATION_TIMES = 'FETCH_RESERVATION_TIMES'
export const SET_RESRVATION_DATES = 'SET_RESRVATION_DATES'
export const SET_SELECTED_RESERVATION_DATE = 'SET_SELECTED_RESERVATION_DATE'
export const SET_CART_DATA = 'SET_CART_DATA'
export const SET_RESERVE_LOADING = 'SET_RESERVE_LOADING'
export const SET_ITINERARIES = 'SET_ITINERARIES'
export const SET_DATES_LOADING = 'SET_DATES_LOADING'
export const SHOW_CONFLICT_MSG = 'SHOW_CONFLICT_MSG'
export const SET_DAY_CONF = 'SET_DAY_CONF'


//Payment
export const START_PAYMENT = 'START_PAYMENT'
export const SET_PAYMENT_LOADER = 'SET_PAYMENT_LOADER'
export const SET_NOTIFICATION_BANNER = 'SET_NOTIFICATION_BANNER'
